import React from 'react';
import { Check } from 'lucide-react';

const BADGES = [
  '12+ Years in Practice',
  'Three Integrated Divisions',
  'Multi-Language Platform',
  'No Long-Term Contracts',
];

export default function TrustSection() {
  return (
    <section className="py-12 md:py-14 bg-[#f5f5f7]">
      <div className="zh-container">
        <h3 className="text-center text-gray-800 text-lg font-medium mb-7">
          Built on more than a decade of practice
        </h3>
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-3">
          {BADGES.map((b) => (
            <div key={b} className="flex items-center gap-2.5 text-gray-700 text-[15px]">
              <Check className="w-4 h-4 text-[#f5a623]" strokeWidth={3} />
              <span>{b}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
